export const assets = {
  curd: "/images/Gomukhi_curd.webp",
  milk: "/images/gomukhi_full_cream_milk.webp",
  paneer: "/images/amogh_lite_paneer.webp",
  khova: "/images/Amogh_khova.webp",
  toned: "/images/srilakshmi_toned_milk.webp",
  fleet: "/images/Fleet-van.webp",
  exterior: "/images/Factory_0.webp",
  processing: "/images/Factory_2.webp",
  production: "/images/Factory_4.webp",
  productsHero: "/images/product_hero.webp",
  amoghCurd: "/images/amogh_curd.webp",
  amoghCurdBucket: "/images/amogh_curd_bucket.webp",
  amoghPaneer: "/images/Amogh_paneer.webp",
  gomukhiDtMilk: "/images/Gomukhi_dt_milk.webp",
  gomukhiStandardized: "/images/gomukhi_standardized_milk.webp",
  gomukhiToned: "/images/gomukhi_toned_milk_pouches.webp",
  slFullCream: "/images/srilakshmi_fullcream_milk.webp",
  slStandardised: "/images/srilakshmi_standardized_milk.webp",
  slButterMilk: "/images/srilakshmi_buttermilk.webp",
  slCurd: "/images/srilakshmi_curd.webp",
  gate: "/images/Factory-gate.webp",
  lawns: "/images/Factory_6.webp",
  shrine: "/images/Temple.webp",
  dusk: "/images/Factory_1.webp",
  packing: "/images/Factory_5.webp",
  farm: "/images/Farm.webp",
  plantInterior: "/images/Factory_3.webp",
  tanker: "/images/Fleet-tanker.webp",
  aerial: "/images/Factory_ariel.webp",
  fleetGarland: "/images/Fleet-garland.webp",
  image1: "/images/1.jpg",
  image5: "/images/5.jpg",
  workersTeam: "/images/1.jpg",
  workersFloor: "/images/5.jpg",
  videoPlant: "/videos/film1.mp4",
  videoPacking: "/videos/film2.mp4",
  videoControl: "/videos/film3.mp4",
  videoInspection: "/videos/film4.mp4",
  farmer: "/images/farmers_to_families..webp",
  farmerProcurement: "/images/Mutual_growth.webp",
  mutualGrowth: "/images/Mutual_growth.webp",
  farmersToFamilies: "/images/farmers_to_families..webp",
  waterTreatment: "/images/water-treatment-system.webp",
  etp: "/images/etp.webp",
  milkProcessingLine: "/images/milk-processing-line.webp",
  processingArea: "/images/processing-area.webp",
  sustainabilityHero: "/images/sustainability.webp",
  aboutUsHero: "/images/about.webp",
  contactHero: "/images/contactus_hero.webp",
  valuesBaba: "/images/baba.webp",
  valuesFounders: "/images/Founders.webp",
};

export const factoryGallery = [
  { title: "The gates of Sairaksha", caption: "Our name on the wall — Santhipuram 7th Mile, Kuppam", image: assets.gate },
  { title: "The Kuppam plant", caption: "Our main processing unit in Kuppam, Andhra Pradesh", image: assets.exterior },
  { title: "A fleet we call our own", caption: "Milk vans blessed and ready for the day's routes", image: assets.fleetGarland },
  { title: "Precision on the processing floor", caption: "Skilled plant technicians operating modern packaging and quality control lines", image: assets.lawns },
  { title: "The heart of processing", caption: "Pasteurisation lines and CIP systems in stainless steel", image: assets.plantInterior },
  { title: "A connected cold chain", caption: "40 insulated vehicles carrying freshness forward", image: assets.fleet },
  { title: "Where every day begins", caption: "The campus shrine at the heart of our plant", image: assets.shrine },
  { title: "Built for precision", caption: "Stainless steel processing and storage systems", image: assets.processing },
  { title: "Milk on the move", caption: "Tankers linking chilling centres to the main plant", image: assets.tanker },
  { title: "Straight from the farm", caption: "Green fields and kitchen gardens at our partner farms", image: assets.farm },
  { title: "Bulk storage & silos", caption: "Temperature-controlled stainless steel holding tanks and automated milk circuits", image: assets.production },
  { title: "Evenings at the plant", caption: "Stone pathways leading to the processing halls", image: assets.dusk },
  { title: "Hygiene on the floor", caption: "Masked, gloved and aproned — every pack weighed and checked", image: assets.packing },
  { title: "Kuppam from above", caption: "Silos, chillers and processing halls under one blue roof", image: assets.aerial },
  { title: "Our dedicated dairy team", caption: "The frontline workers and operators ensuring quality and hygiene in every batch", image: assets.image1 },
  { title: "Employee dining area", caption: "Clean and comfortable dining facilities for our dedicated plant staff", image: assets.image5 },
];

export const plantVideos = [
  { title: "Inside the Plant", caption: "A walkthrough of our processing facility.", video: assets.videoPlant, poster: "/posters/film1.jpg" },
  { title: "Packing & Dispatch", caption: "Products organised for same-day delivery.", video: assets.videoPacking, poster: "/posters/film2.jpg" },
  { title: "Process Control", caption: "Every parameter monitored in real time.", video: assets.videoControl, poster: "/posters/film3.jpg" },
  { title: "Quality Check", caption: "Every batch inspected before it leaves the floor.", video: assets.videoInspection, poster: "/posters/film4.jpg" },
];

export const products = [
  { name: "Full Cream Milk", brand: "Gomukhi", category: "Milk", image: assets.milk, note: "Rich, creamy and full of natural goodness." },
  { name: "Standardized Milk", brand: "Gomukhi", category: "Milk", image: assets.gomukhiStandardized, note: "Consistent richness in every pouch." },
  { name: "Toned Milk", brand: "Gomukhi", category: "Milk", image: assets.gomukhiToned, note: "Multiple pouch sizes for every family." },
  { name: "Double Toned Milk", brand: "Gomukhi", category: "Milk", image: assets.gomukhiDtMilk, note: "Light on fat, full on nutrition." },
  { name: "Fresh Curd", brand: "Gomukhi", category: "Fresh Curd", image: assets.curd, note: "Made with pure cow milk — thick and naturally set." },
  { name: "Curd", brand: "Amogh", category: "Fresh Curd", image: assets.amoghCurd, note: "Convenient family pouches — farm fresh for a healthy family." },
  { name: "Bucket Curd", brand: "Amogh", category: "Fresh Curd", image: assets.amoghCurdBucket, note: "Bulk buckets for households, hotels and caterers." },
  { name: "Paneer", brand: "Amogh", category: "Dairy foods", image: assets.amoghPaneer, note: "Soft, power-packed protein — perfect for curries, tikka and salads." },
  { name: "Lite Paneer", brand: "Amogh", category: "Dairy foods", image: assets.paneer, note: "Power packed protein, lighter on fat." },
  { name: "Unsweetened Khova", brand: "Amogh", category: "Dairy foods", image: assets.khova, note: "For healthy sweets and festive cooking." },
  { name: "Full Cream Milk", brand: "Sri Lakshmi", category: "Milk", image: assets.slFullCream, note: "Rich and creamy — care for your health in every glass." },
  { name: "Standardised Milk", brand: "Sri Lakshmi", category: "Milk", image: assets.slStandardised, note: "Consistent quality, pasteurised and homogenised." },
  { name: "Double Toned Milk", brand: "Sri Lakshmi", category: "Milk", image: assets.toned, note: "Pasteurised & homogenised — care for your health." },
  { name: "Butter Milk", brand: "Sri Lakshmi", category: "Butter Milk", image: assets.slButterMilk, note: "Light, refreshing and cooling — the everyday thirst quencher." },
  { name: "Curd", brand: "Sri Lakshmi", category: "Fresh Curd", image: assets.slCurd, note: "Thick, naturally set curd in family pouches." },
];

export const brands = [
  { name: "Gomukhi", sub: "Quality · Purity", color: "terracotta", text: "Everyday milk and cultured favourites, made with care." },
  { name: "Amogh", sub: "Farm fresh", color: "sun", text: "Paneer, curd and khova made for nourishing family moments." },
  { name: "Sri Lakshmi", sub: "Care for your health", color: "lemon", text: "A trusted choice for simple, wholesome milk." },
];

export const purityChecks = [
  { icon: "ShieldCheck", title: "Antibiotic-Free Testing", text: "Every batch is screened to ensure zero antibiotic residues before processing begins.", stat: "100%", statLabel: "Tested" },
  { icon: "Thermometer", title: "Pasteurisation Safety Check", text: "Milk is pasteurised at precise temperatures to eliminate harmful bacteria while preserving nutrition.", stat: "72°C", statLabel: "Precision" },
  { icon: "FlaskConical", title: "Quality Lab Inspection", text: "Our in-house lab tests for fat content, SNF, adulteration and microbial safety.", stat: "50+", statLabel: "Tests" },
  { icon: "PackageCheck", title: "Hygienic Automated Packaging", text: "Sealed on fully automated lines with zero human contact to guarantee purity.", stat: "0%", statLabel: "Contact" },
];

export const timeline = [
  { year: "2012", title: "Foundation", text: "Started our journey with 5,000 litres of milk per day.", tag: "5,000 litres / day", icon: "Flag" },
  { year: "2015", title: "A Connected Network", text: "Expanded our collection network with chilling centres and village-level procurement.", tag: "3 Chilling Centres", icon: "Snowflake" },
  { year: "2019", title: "Multi-State Reach", text: "Extended our distribution across Andhra Pradesh, Karnataka, Tamil Nadu and Telangana.", tag: "4 States", icon: "MapPin" },
  { year: "2022", title: "Scale with Care", text: "Daily sales grew to 70,000 litres of milk & curd and 2,000 kg of paneer.", tag: "70,000 litres / day", icon: "TrendingUp" },
  { year: "2024", title: "₹100 Crore Turnover", text: "Achieved a turnover of ₹100 crore, backed by expanded operations and capacity.", tag: "₹100 Crore", icon: "Award" },
  { year: "2027", title: "The SMP Vision", text: "Planning a Skimmed Milk Powder (SMP) plant of 25 MT per day at Kuppam.", tag: "25 MT / day", icon: "Factory" },
];

export const fssaiNumber = "10118010000287";

export const locations = [
  { 
    name: "Kuppam Packing Unit", 
    capacity: "1,00,000 litres / day",  
    role: "Main Plant", 
    region: "Santhipuram Mandal, Chittoor Dist",
    isMain: true 
  },
  { 
    name: "Rayakotai CC", 
    capacity: "50,000 litres / day", 
    role: "Chilling Centre", 
    region: "Krishnagiri Region",
    isMain: false 
  },
  { 
    name: "Thirupathur CC", 
    capacity: "50,000 litres / day", 
    role: "Chilling Centre", 
    region: "Tirupattur Region",
    isMain: false 
  },
  { 
    name: "Indure CC", 
    capacity: "10,000 litres / day", 
    role: "Chilling Centre", 
    region: "Kuppam Outer Radius",
    isMain: false 
  },
];

export const empowerment = [
  { icon: "IndianRupee", title: "Fair Pricing", text: "Transparent, competitive pricing based on fat and SNF quality parameters. No middlemen, no exploitation." },
  { icon: "GraduationCap", title: "Training Programs", text: "Regular workshops on cattle management, feed optimisation and clean milking practices." },
  { icon: "Stethoscope", title: "Veterinary Support", text: "Veterinary camps and on-call support for cattle health and breeding assistance." },
  { icon: "TrendingUp", title: "Growth Partnerships", text: "Support for farmers to expand their herds and improve yield season after season." },
  { icon: "Users", title: "Community Building", text: "Farmer groups and women's dairy groups fostering collective growth across villages." },
  { icon: "ShieldCheck", title: "Insurance Support", text: "Cattle insurance schemes protecting farmers from unforeseen losses." },
];
